import { Random, Vector, vec } from 'excalibur';

export interface PlacementRect {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export function randomPointInRect(rng: Random, rect: PlacementRect): Vector {
  return vec(rng.floating(rect.left, rect.right), rng.floating(rect.top, rect.bottom));
}

export function randomPointInRects(rng: Random, rects: PlacementRect[]): Vector {
  if (rects.length === 0) {
    return vec(0, 0);
  }
  const weights = rects.map((rect) => Math.max(1, (rect.right - rect.left) * (rect.bottom - rect.top)));
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  let pick = rng.floating(0, total);
  for (let i = 0; i < rects.length; i++) {
    pick -= weights[i];
    if (pick <= 0) {
      return randomPointInRect(rng, rects[i]);
    }
  }
  return randomPointInRect(rng, rects[rects.length - 1]);
}
